// extracted by mini-css-extract-plugin
export default {"container":"SloganSection_container__ogzJt","slogan":"SloganSection_slogan__xGJ2o","highlight":"SloganSection_highlight__XpdNQ"};